const style = (theme) => {
  const output = {
    root: {
      overflow: 'hidden',
      borderRadius: 16,
    },
    rootReverse: {
      '& $image': {
        order: 999,
      },
    },
    rootBackground: {
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      backgroundColor: theme.colors[3],
    },
    wrapper: {
      display: 'flex',
    },
    image: {
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      width: '60%',
      '&::before': {
        content: '""',
        zIndex: 1,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        paddingBottom: '52%',
      },
    },
    info: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      lineHeight: 1,
      padding: 60,
      flex: 1,
      '& > *:not(:last-child)': {
        marginBottom: 25,
      },
    },
    title: {
      fontSize: 24,
    },
    category: {
      fontSize: 10,
      textTransform: 'uppercase',
      color: theme.colors[1],
      marginBottom: 20,
      paddingLeft: 2,
    },
    description: {
      fontSize: 16,
    },
    hover: {},
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    rootReverse: {
      '& $image': {
        order: 0,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapper: {
      flexDirection: 'column',
    },
    image: {
      width: '100%',
      '&::before': {
        paddingBottom: '56.25%',
      },
    },
    info: {
      padding: 40,
    },
    category: {
      paddingLeft: 0,
    },
  }

  return output
}

export default style
